/**
 * AgentFloatingNav — compact left-edge dock for New chat + History.
 * Replaces the full-width sub-nav rail and heavy drawer pattern.
 */

import { History, MessageSquarePlus } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface AgentFloatingNavProps {
  historyOpen: boolean;
  onNewChat: () => void;
  onToggleHistory: () => void;
}

const AgentFloatingNav: React.FC<AgentFloatingNavProps> = ({
  historyOpen,
  onNewChat,
  onToggleHistory,
}) => {
  const { t } = useTranslation();
  const newChat = t('agent.chrome.newChat', { defaultValue: 'New chat' });
  return (
  <nav
    className="agent-floating-nav"
    aria-label="Agent shortcuts"
  >
    <button
      type="button"
      onClick={onNewChat}
      className="agent-floating-nav__btn agent-floating-nav__btn--primary"
      title={newChat}
      aria-label={newChat}
    >
      <MessageSquarePlus className="w-[18px] h-[18px]" strokeWidth={2} aria-hidden />
    </button>
    <button
      type="button"
      onClick={onToggleHistory}
      aria-pressed={historyOpen}
      aria-expanded={historyOpen}
      className={`agent-floating-nav__btn ${historyOpen ? 'is-active' : ''}`}
      title={historyOpen ? 'Hide history' : 'Chat history'}
      aria-label={historyOpen ? 'Hide history' : 'Chat history'}
    >
      <History className="w-[18px] h-[18px]" aria-hidden />
    </button>
  </nav>
  );
};

export default AgentFloatingNav;
